let prevBox = [0,0,0,0]
const CompareBox=(_ne,_sw)=>{

    let warrant = true

    let [maxX,minY,minX, maxY] = [..._ne.split(','),..._sw.split(',')]
    let [maxXPrev, minYPrev, minXPrev, maxYPrev] =  prevBox
    if (minX >= minXPrev && minY <= minYPrev && maxX <= maxXPrev && maxY >= maxYPrev){
        warrant = false
        }
    prevBox = [parseFloat(maxX),parseFloat(minY),parseFloat(minX), parseFloat(maxY)]
return warrant

}

export const resetBox = () => { prevBox = [0,0,0,0] }

export default CompareBox